import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { RouterModule }   from '@angular/router';
import { HttpModule } from '@angular/http';
import { RecaptchaModule } from 'ng-recaptcha';

import { AppComponent } from './app.component';
import { Break1Component } from './break1/break1.component';
import { Break2Component } from './break2/break2.component';
import { Break3Component } from './break3/break3.component';
import { Break4Component } from './break4/break4.component';
import { Break5Component } from './break5/break5.component';
import { Break6Component } from './break6/break6.component';
import { Break7Component } from './break7/break7.component';
import { LoginComponent } from './login/login.component';
import { LoginGameComponent } from './login-game/login-game.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ProfileDiscoveryComponent } from './profile-discovery/profile-discovery.component';
import { QuizComponent } from './quiz/quiz.component';
import { ValidateEmailComponent } from './validate-email/validate-email.component';

import { SharedService } from './shared.service';
import { LoginService } from './login.service';
import { LoginGameService } from './login-game.service';
import { QuizService } from './quiz.service';
import { Break1Service } from './break1.service';
import { Break2Service } from './break2.service';
import { Break3Service } from './break3.service';
import { Break4Service } from './break4.service';
import { Break5Service } from './break5.service';
import { Break6Service } from './break6.service';
import { Break7Service } from './break7.service';
import { Break8Service } from './break8.service';
import { Break9Service } from './break9.service';
import { Break10Service } from './break10.service';
import { Break11Service } from './break11.service';
import { ProfileDiscoveryService } from './profile-discovery.service';
import { ValidateEmailService } from './validate-email.service';

import { routing } from './app.routing';
import { Break8Component } from './break8/break8.component';
import { Break9Component } from './break9/break9.component';
import { Break10Component } from './break10/break10.component';
import { Break11Component } from './break11/break11.component';
import { TopicComponent } from './topic/topic.component';
import { MerciComponent } from './merci/merci.component';
import { InviteComponent } from './invite/invite.component';
import { Break12Component } from './break12/break12.component';
import { Break13Component } from './break13/break13.component';
import { Break14Component } from './break14/break14.component';
import { Break15Component } from './break15/break15.component';
import { Break16Component } from './break16/break16.component';
import { Break17Component } from './break17/break17.component';
import { Break18Component } from './break18/break18.component';
import { Break19Component } from './break19/break19.component';
import { Break20Component } from './break20/break20.component';
import { Break21Component } from './break21/break21.component';
import { Break22Component } from './break22/break22.component';
import { Break23Component } from './break23/break23.component';
import { Break24Component } from './break24/break24.component';
import { Break25Component } from './break25/break25.component';
import { Break26Component } from './break26/break26.component';

@NgModule({
  declarations: [
    AppComponent,
    Break1Component,
    Break2Component,
    Break3Component,
    Break4Component,
    Break5Component,
    Break6Component,
    Break7Component,
    LoginComponent,
    LoginGameComponent,
    PageNotFoundComponent,
    ProfileDiscoveryComponent,
    QuizComponent,
    ValidateEmailComponent,
    Break8Component,
    Break9Component,
    Break10Component,
    Break11Component,
    TopicComponent,
    MerciComponent,
    InviteComponent,
    Break12Component,
    Break13Component,
    Break14Component,
    Break15Component,
    Break16Component,
    Break17Component,
    Break18Component,
    Break19Component,
    Break20Component,
    Break21Component,
    Break22Component,
    Break23Component,
    Break24Component,
    Break25Component,
    Break26Component,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    RecaptchaModule.forRoot(),
    RouterModule.forRoot(routing)
  ],
  providers: [
    LoginService,
    SharedService,
    LoginGameService,
    QuizService,
    Break1Service,
    Break2Service,
    Break3Service,
    Break4Service,
    Break5Service,
    Break6Service,
    Break7Service,
    Break8Service,
    Break9Service,
    Break10Service,
    Break11Service,
    ProfileDiscoveryService,
    ValidateEmailService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/app.module.ts